module.exports = __webpack_public_path__ + "files/1a033c701784a642df14e6d1ff8ef0ff.png";